import React from 'react';


import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
// import FormLabel from '@mui/material/FormLabel';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { useAuth0 } from "@auth0/auth0-react";
import { Amplify } from "aws-amplify"
import type { Schema } from "../amplify/data/resource"
import { generateClient } from "aws-amplify/api"


import './index.scss';
import outputs from "./amplify_outputs.json"

// import { Title } from '@mui/icons-material';
import { LogoutButton } from './components/logoutButton';
import { Grid } from '@mui/material';


   

  export default function Home() {

    const { user } = useAuth0();

    const [value, setValue] = React.useState('1');
    const [accountValue, setAccountValue] = React.useState("A00000007");
    const [vinsValue, setVinsValue] = React.useState("TESTING0003");
    const [vinsDatesValue, setVinsDatesValue] = React.useState("TESTING0003,2025-09-13");
    const [ratePlanValue, setRatePlanValue] = React.useState("DM Customer Renewal");
    const [orderValue, setOrderValue] = React.useState("");
    const [subsValue, setSubsValue] = React.useState("");
    const [jsonsValue, setJsonsValue] = React.useState("{\"timestamp\": \"2025-03-22T20:37:48.312Z\",\"id\": \"150cc072-c3d7-4971-99f0-2ce53a5f3cfc\",\"customerName\": \"Unknown\",\"vehicleIdentificationNumber\": \"TestingVIN\",\"warrantyCode\": \"fds\",\"warrantyDesc\": \"fds\", \"coverage\": \"3\", \"inServiceDate\": \"2019-04-10\", \"notInService\": \"false\" }");

    const [openSucc, setOpenSucc] = React.useState(false);
    const [openFail, setOpenFail] = React.useState(false);
    const [succMessage, setSuccMessage] = React.useState("");
    const [failMessage, setFailMessage] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [open, setOpen] = React.useState(false);

    const [clientid, setclientid] = React.useState('');
    const [clientsecret, setclientsecret] = React.useState('');

    Amplify.configure(outputs)

    const client = generateClient<Schema>()


    const handleClickOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
    setOpen(false);
    };

    
      
    const handleClickOpenSucc = (message: React.SetStateAction<string>) => {
        handleCloseSucc();
        handleCloseFail();
        setLoading(false);
        setOpenSucc(true);
        setSuccMessage(message);
    };
    
    const handleCloseSucc = () => {
        setOpenSucc(false);
        setSuccMessage("");
    };

    const handleClickOpenFail = (message: React.SetStateAction<string>) => {
        handleCloseSucc();
        handleCloseFail();
        setLoading(false);
        setOpenFail(true);
        setFailMessage(message);
    };
    
    const handleCloseFail = () => {
        setOpenFail(false);
        setFailMessage("");
    };

    const handleClientidChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setclientid(event.target.value);
    };
    const handleClientsecretChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setclientsecret(event.target.value);
    };

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    const handleAccountChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setAccountValue(event.target.value);
    };
    const handleVinsChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setVinsValue(event.target.value);
    };
    const handleVinsDatesChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setVinsDatesValue(event.target.value);
    };
    const handleRatePlanChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRatePlanValue((event.target as HTMLInputElement).value);
    };
    const handleOrderChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setOrderValue(event.target.value);
    }; 
    const handleSubsChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setSubsValue(event.target.value);
    };   
    const handleJsonsChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setJsonsValue(event.target.value);
    };   

    const apiEndpoint = process.env.REACT_APP_API_ENDPOINT + '/ssutil/backend';
    // const apiEndpoint = "https://ssutil.dev.cvp.paccar.cloud/ssutil/backend"

    console.info(apiEndpoint);
    
    const submitZuoraAccountInfo = () => {
        
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "setZuoraAccountDetails",
            email: user?.email,
            clientid: clientid,
            clientsecret: clientsecret 
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
        handleClose();
    }
    
    function createOrders() {
        setLoading(true);        
        client.queries.ssUtilFunction({
            func: "createOrders",
            email: user?.email,
            account: accountValue,
            vins: vinsValue 
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }

    function unsubscribeOrder() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "unsubscribeOrder",
            email: user?.email,
            vins: vinsValue 
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }

    function createExtensionOrders() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "createExtensionOrders",
            rateplan: ratePlanValue,
            email: user?.email,
            vins: vinsDatesValue 
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }
    function removeOrders() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "removeOrders",
            email: user?.email,
            orders: orderValue 
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }
    function cancelSubscriptions() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "cancelSubscriptions",
            email: user?.email,
            subs: subsValue 
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }
    function RegisterVehicle() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "RegisterVehicle",
            email: user?.email,
            jsons: jsonsValue 
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }
    function subscriptionTransfer() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "subscriptionTransfer",
            email: user?.email,
            subs: subsValue,
            account: accountValue
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }
    function updatePS() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "updatePS",
            email: user?.email,
            vins: vinsDatesValue,
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }
    function deleteZrAccounts() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "deleteZrAccounts",
            email: user?.email,
            account: accountValue,
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }
    function readDLQ() {
        setLoading(true);
        client.queries.ssUtilFunction({
            func: "readDLQ",
            email: user?.email,
        }).then((response) => {
            if(typeof response.data ==="string") {
                const data = JSON.parse(response.data)["body"];
                if (data.split(' ')[0] === "Error:") {
                    handleClickOpenFail(data);
                } else if (typeof data === "string"){
                    handleClickOpenSucc(data);
                } else {
                    handleClickOpenFail("Unknown response from backend");
                }
            }
            else {
                handleClickOpenFail("Unexpected response format");
            }
        }).catch((error) => {
            console.error(error)
        })
    }
    return (
        
            <Box sx={{ width: '100%', typography: 'body1',whiteSpace: 'pre-line' }}>
                <Collapse in={openFail}>
                    <Alert 
                        severity="error" 
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    handleCloseFail();
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}>
                            
                        <AlertTitle>Error</AlertTitle>
                        {failMessage}
                    </Alert>
                </Collapse>
                <Collapse in={openSucc}>
                    <Alert 
                        severity="success" 
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    handleCloseSucc();
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}>
                            
                        <AlertTitle>Success</AlertTitle>
                        {succMessage}
                    </Alert>
                </Collapse>
                <h1> SSUTIL </h1>
                <Grid container justifyContent="flex-end">
                    <Button className="button__config" onClick={handleClickOpen}>
                        Configure Zuora Account
                    </Button>
                    <LogoutButton />
                </Grid>

                <Dialog
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                    component: 'form',
                    onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                        event.preventDefault();
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries((formData as any).entries());
                        const email = formJson.email;
                        console.log(email);
                        handleClose();
                    },
                    }}
                >
                    <DialogTitle>Zuora Account</DialogTitle>
                    <DialogContent>
                    <DialogContentText>
                        Need Zuora Account Client id and Client secret 
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="Clientid"
                        name="Clientid"
                        label="Client id"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={handleClientidChange}
                    />
                    <TextField
                        required
                        margin="dense"
                        id="Clientsecret"
                        name="Clientsecret"
                        label="Client Secret"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={handleClientsecretChange}
                    />
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={submitZuoraAccountInfo}>Save</Button>
                    </DialogActions>
                </Dialog>

                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs 
                        value={value} 
                        onChange={handleChange} 
                        aria-label="lab API tabs example"
                        textColor="secondary"
                        indicatorColor="secondary"
                        //variant="fullWidth"
                        variant="scrollable"
                        scrollButtons="auto"
                        >
                            <Tab label="Policy Orders" value="1" wrapped/>
                            <Tab label="Subscription Extensions" value="2" wrapped/>
                            <Tab label="Remove Orders" value="3" wrapped/>
                            <Tab label="Cancel Subscriptions" value="4" wrapped/>
                            {/* <Tab label="Generate Text File" value="5" wrapped/> */}
                            <Tab label="Subscription Transfer" value="6" wrapped/>
                            <Tab label="New Warranty" value="7" wrapped/>
                            <Tab label="Update Trimble End Date" value="8" wrapped/>
                            <Tab label="Delete Zuora Accounts" value="9" wrapped/>
                            <Tab label="DLQ Processing" value="10" wrapped/>
                            <Tab label="Account Settings" value="11" wrapped/>
                        </Tabs>
                    </Box>
                    <TabPanel value="1">
                        <h2>Policy Orders</h2>
                        <FormControl>
                            <p> Account: </p>
                            <TextField id="account" label="Account" variant="outlined" placeholder={accountValue} onChange={handleAccountChange}/>

                            <p> VINs (new line seperated): </p>
                            <TextField
                            id="vins"
                            label="VINs"
                            placeholder={vinsValue}
                            onChange={handleVinsChange}
                            multiline 
                            />

                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button"  onClick={createOrders} disabled={loading}>Subscribe
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                                <Button className="button" variant="outlined" onClick={unsubscribeOrder} disabled={loading}>Unsubscribe
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                                
                            </Stack>
                        </FormControl>
                    </TabPanel>
                    <TabPanel value="2">
                        <h2>Subscription Extensions</h2>
                        
                        <FormControl>
                            <p> Please choose a rate plan that should be used in the extension </p>
                            <RadioGroup
                                aria-labelledby="rate-plan-selection"
                                defaultValue="DM Customer Renewal"
                                name="rate-plan-selection-radio-buttons-group"
                                value = {ratePlanValue}
                                onChange={handleRatePlanChange}
                            >
                            <FormControlLabel value="DM Customer Renewal" control={<Radio />} label="DM Customer Renewal" />
                            <FormControlLabel value="Point Of Sale" control={<Radio />} label="Point Of Sale" />
                            </RadioGroup>

                            <p> Vins and End Dates (comma seperated, see example below): </p>
                            <TextField
                                id="vins-enddates"
                                label="VIN,YYYY-MM-DD"
                                placeholder={vinsDatesValue}
                                onChange={handleVinsDatesChange}
                                multiline 
                            />
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" onClick={createExtensionOrders} disabled={loading}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel>
                    <TabPanel value="3">
                        <h2>Remove Orders</h2>

                        <FormControl>
                            <p> Orders to be deleted(new line seperated): </p>
                            <TextField
                                id="orderes-to-be-deleted"
                                label="Orders"
                                onChange={handleOrderChange}
                                multiline 
                            />
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" onClick={removeOrders} disabled={loading}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel>
                    <TabPanel value="4">
                        <h2>Cancel Subscriptions</h2>

                        <FormControl>
                            <p> Subscriptions to be deleted(new line seperated): </p>
                            <TextField
                                id="orderes-to-be-deleted"
                                label="Subscriptions"
                                onChange={handleSubsChange}
                                multiline 
                            />
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" onClick={cancelSubscriptions} disabled={loading}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel>
                    {/* <TabPanel value="5">
                        <h2>Generate Text File</h2>

                        <FormControl>
                            <p> Click to generate VINs to Subscription names </p>
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" disabled={loading}>Generate VTS File
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel> */}
                    <TabPanel value="6">
                        <h2>Subscription Transfer</h2>

                        <FormControl>
                        
                            <p> Subscription Numbers to be transfered (new line seperated): </p>
                            <TextField
                            id="vins"
                            label="Subscriptions"
                            onChange={handleSubsChange}
                            multiline 
                            />

                            <p> Account Number to Receive: </p>
                            <TextField id="account" label="Account" variant="outlined" onChange={handleAccountChange}/>

                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" onClick={subscriptionTransfer} disabled={loading}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel>
                    <TabPanel value="7">
                        <h2>New Warranty</h2>

                        <FormControl>
                            <p> JSON Message(new line seperated): </p>
                            <TextField
                                id="orderes-to-be-deleted"
                                label="Jsons"
                                onChange={handleJsonsChange}
                                placeholder={jsonsValue}
                                sx={{
                                    //color: green[500],
                                    maxWidth: '250px',
                                }}
                                multiline 
                            />
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" disabled={loading} onClick={RegisterVehicle}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel>
                    <TabPanel value="8">
                        <h2>Update Trimble End Date</h2>

                        <FormControl>

                            <p> Vins and End Dates (comma seperated, see example below): </p>
                            <TextField
                                id="vins-enddates-2"
                                label="TESTING0003,2023-01-22"
                                onChange={handleVinsDatesChange}
                                multiline 
                            />
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" disabled={loading} onClick={updatePS}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel>
                    <TabPanel value="9">
                        <h2>Delete Zuora Accounts</h2>

                        <FormControl>
                            <p> Zuora Account ID's to be deleted(new line seperated): </p>
                            <TextField
                                id="accounts-to-be-deleted"
                                label="Account ID's"
                                onChange={handleAccountChange}
                                multiline 
                            />
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" disabled={loading} onClick={deleteZrAccounts}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel>
                    <TabPanel value="10">
                        <h2>DLQ Processing</h2>
                        <FormControl>
                            <p> By clicking submit you will read all the messages in the DLQ. They will be written to a file and the chassis bi file will be generated for these vehicles. The messages will need to be entered into the warranty processing tab after trimble consumes the file </p>
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" disabled={loading} onClick={readDLQ}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>

                            <p> By clicking submit you will write hard coded messages to ITD Warranty Queue </p>
                            <Stack className="stack" spacing={2} direction="row">
                                <Button variant="outlined" className="button" disabled={true}>Submit
                                {loading && (
                                    <CircularProgress
                                        size={24}
                                        sx={{
                                        //color: green[500],
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                        }}
                                    />
                                )}
                                </Button>
                            </Stack>
                        </FormControl>
                    </TabPanel>
                </TabContext>
            </Box>
    )
    
  }

    // ============================================================
  